
[
  {
    "id": "TIJD-PAT-L1-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Kijk naar de rij: 2 - 4 - 8 - 16 - ... Welk getal komt daarna?",
    "options": ["32", "24", "20", "18"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "patronen",
    "familyId": "TIJD-PAT-VERMENIGVULDIG",
    "explanation": "Elk getal wordt verdubbeld (×2). 2 × 2 = 4, 4 × 2 = 8, 8 × 2 = 16, 16 × 2 = 32.",
    "distractorExplanations": { "1": "Je deed +8. Maar de getallen worden verdubbeld, niet opgeteld!", "2": "Je deed +4. Maar kijk: 2 → 4 → 8 → 16. Dat is steeds ×2!", "3": "Je deed +2. Maar de sprongen worden steeds groter (×2)." }
  },
  {
    "id": "TIJD-PAT-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Toms zakgeld: Week 1: €2. Week 2: €4. Week 3: €6. Hoeveel krijgt hij in Week 5?",
    "options": ["€ 10", "€ 8", "€ 12", "€ 5"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "patronen",
    "familyId": "TIJD-PAT-ZAKGELD",
    "explanation": "Elk week komt er €2 bij (de tafel van 2). Week 4 is €8, dus Week 5 is €10.",
    "distractorExplanations": { "1": "Dit is Week 4! De vraag gaat over Week 5.", "2": "Je bent te ver gegaan. Dit is Week 6!", "3": "Je hebt naar het weeknummer gekeken. Maar het bedrag is het weeknummer keer 2!" },
    "visualAid": { "type": "ratio", "data": { "headers": ["Week", "Zakgeld"], "rows": [["Week 1", "€ 2"], ["Week 2", "€ 4"], ["Week 3", "€ 6"], ["Week 4", "€ 8"], ["Week 5", "€ 10"]], "highlightRow": 4 }, "showWhen": "wrong" }
  },
  {
    "id": "TIJD-PAT-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Welk getal past in de rij: 5 - 10 - 20 - ... - 80?",
    "options": ["40", "30", "50", "60"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "patronen",
    "familyId": "TIJD-PAT-SPRINGEN",
    "explanation": "Elk getal wordt verdubbeld (×2). 5 × 2 = 10, 10 × 2 = 20, 20 × 2 = 40, 40 × 2 = 80.",
    "distractorExplanations": { "1": "Je deed +10. Maar de getallen worden verdubbeld!", "2": "Je deed +30. Maar kijk: 5 → 10 → 20 → 40 → 80. Steeds ×2!", "3": "Je deed +20. Maar de sprongen worden steeds groter (×2)." }
  },
  {
    "id": "TIJD-TAB-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Toets resultaten: Klas A gemiddeld 7,5. Klas B gemiddeld 8,2. Hoeveel hoger scoort klas B?",
    "options": ["0,7 punt", "0,5 punt", "1,0 punt", "0,3 punt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-VERSCHIL",
    "explanation": "Klas B scoort 8,2 en Klas A scoort 7,5. Het verschil is 8,2 - 7,5 = 0,7 punt.",
    "distractorExplanations": { "1": "Je hebt verkeerd afgetrokken. 8,2 - 7,5 = 0,7, niet 0,5.", "2": "Je hebt te veel afgetrokken. 8,2 - 7,5 = 0,7, niet 1,0.", "3": "Je hebt te weinig afgetrokken. 8,2 - 7,5 = 0,7, niet 0,3." }
  },
  {
    "id": "TIJD-TAB-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Verkoop tabel: Maandag 15 broodjes, Dinsdag 23 broodjes, Woensdag 18 broodjes. Hoeveel in totaal?",
    "options": ["56 broodjes", "46 broodjes", "66 broodjes", "38 broodjes"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-TOTAAL",
    "explanation": "Tel alle broodjes op: 15 + 23 + 18 = 56 broodjes.",
    "distractorExplanations": { "1": "Je bent 10 vergeten. 15 + 23 + 18 = 56, niet 46.", "2": "Je hebt 10 te veel geteld. 15 + 23 + 18 = 56, niet 66.", "3": "Je bent woensdag vergeten. Tel alle drie de dagen op!" }
  },
  {
    "id": "TIJD-DUR-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "De trein vertrekt elk half uur. De eerste trein gaat om 09:15. Hoe laat gaat de volgende?",
    "options": ["09:45", "09:30", "10:15", "09:55"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-DUR-TREIN",
    "explanation": "Een half uur is 30 minuten. Tel op: 15 + 30 = 45 minuten. Dus 09:45 uur.",
    "distractorExplanations": { "1": "Je hebt er maar 15 minuten bijgedaan (een kwartier). Maar een half uur is 30 minuten!", "2": "Dit is een heel uur later. Maar de trein gaat elk half uur!", "3": "Rekenfoutje: 15 + 30 = 45, niet 55." },
    "visualAid": { "type": "rule", "data": { "title": "Tijd Optellen", "content": "Een half uur = 30 minuten. Tel de minuten op: 15 + 30 = 45 minuten.", "icon": "lightbulb" }, "showWhen": "wrong" }
  },
  {
    "id": "TIJD-DUR-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Je vertrekt om 08:45 en komt aan om 10:15. Hoe lang heb je gereisd?",
    "options": ["1 uur en 30 minuten", "1 uur en 15 minuten", "2 uur", "1 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-DUR-REISTIJD",
    "explanation": "Van 08:45 naar 10:15. Eerst naar 09:45 (1 uur), dan naar 10:15 (30 min). Totaal: 1 uur en 30 minuten.",
    "distractorExplanations": { "1": "Je bent 15 minuten vergeten. Van 08:45 naar 10:15 is 1,5 uur.", "2": "Je hebt te veel geteld. Van 08:45 naar 10:15 is 1,5 uur, niet 2 uur.", "3": "Je bent 30 minuten vergeten. Van 08:45 naar 10:15 is 1,5 uur." }
  },
  {
    "id": "TIJD-KLOK-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "De klok toont 09:15:30. Hoeveel seconden is het na kwart over negen?",
    "options": ["30 seconden", "15 seconden", "45 seconden", "1 minuut"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "klokkijken",
    "subSkill": "klokkijken_seconden",
    "familyId": "TIJD-KLOK-NA-KWARTIER",
    "explanation": "De klok toont 09:15:30. De laatste twee cijfers (30) zijn de seconden. Het is dus 30 seconden na kwart over negen.",
    "distractorExplanations": { "1": "15 zijn de minuten, niet de seconden!", "2": "45 seconden zou 09:15:45 zijn.", "3": "1 minuut zou 09:16:00 zijn." },
    "visualAid": { "type": "rule", "data": { "title": "Digitale Klok Lezen", "content": "Formaat: uu:mm:ss (uren:minuten:seconden). De laatste twee cijfers zijn altijd de seconden!", "icon": "lightbulb" }, "showWhen": "wrong" }
  },
  {
    "id": "TIJD-KLOK-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Een race duurt 2 minuten en 45 seconden. Hoeveel seconden is dat in totaal?",
    "options": ["165 seconden", "145 seconden", "245 seconden", "125 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TIJD-KLOK-RACE",
    "explanation": "2 minuten = 2 × 60 = 120 seconden. Plus 45 seconden = 165 seconden totaal.",
    "distractorExplanations": { "1": "Je bent de 2 minuten vergeten om te rekenen! 2 min = 120 sec.", "2": "Rekenfout. 2 × 60 = 120, plus 45 = 165.", "3": "Je hebt verkeerd gerekend. Check: 120 + 45 = 165." }
  },
  {
    "id": "TIJD-KLOK-L2-003",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "De klok staat op 11:58:40. Over hoeveel seconden is het 12:00:00?",
    "options": ["80 seconden", "60 seconden", "120 seconden", "20 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-KLOK-AFTELLEN",
    "explanation": "Van 11:58:40 naar 12:00:00. Eerst naar 11:59:00 (20 sec), dan naar 12:00:00 (60 sec). Totaal: 20 + 60 = 80 seconden.",
    "distractorExplanations": { "1": "60 seconden is maar tot 11:59:40. Je moet nog 20 seconden verder!", "2": "120 seconden is te veel. Check: 20 + 60 = 80.", "3": "20 seconden is maar tot 11:59:00. Je moet nog een minuut verder!" }
  },
  {
    "id": "TIJD-KLOK-INT-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Hoe laat is het precies? Let ook op de secondewijzer!",
    "options": ["09:15:30", "09:03:06", "21:15:30", "09:30:15"],
    "correctAnswer": 0,
    "questionType": "klok_aflezen",
    "skill": "klokkijken",
    "subSkill": "klokkijken_seconden",
    "familyId": "TIJD-KLOK-INT-SEC",
    "context": "Het is 's ochtends. De eerste les is net begonnen.",
    "explanation": "Het is 's ochtends. Uur: 9. Minuten: 15 (kwart over). Seconden: 30 (halve minuut). Dus 09:15:30.",
    "distractorExplanations": { "1": "Je hebt de cijfers gelezen (3 en 6) in plaats van minuten/seconden.", "2": "21:15:30 is 's avonds. Maar de context zegt dat het 's ochtends is!", "3": "Je hebt minuten en seconden omgedraaid." }
  },
  {
    "id": "GELD-SAMEN-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Maak precies €5,25",
    "options": ["500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 525,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-COMBO-1",
    "explanation": "Je moet €5,25 maken. Bijvoorbeeld: €5 + 20 cent + 5 cent = €5,25.",
    "distractorExplanations": { "1": "Je hebt te weinig gekozen. €5,25 is 525 cent.", "2": "Je hebt te veel gekozen. Tel je munten nog eens na.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-SAMEN-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Maak precies €8,65",
    "options": ["500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 865,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-COMBO-2",
    "explanation": "Je moet €8,65 maken. Bijvoorbeeld: €5 + €2 + €1 + 50 cent + 10 cent + 5 cent = €8,65.",
    "distractorExplanations": { "1": "Je hebt te weinig gekozen. €8,65 is 865 cent.", "2": "Je hebt te veel gekozen. Tel je munten nog eens na.", "3": "Je bent 50 cent vergeten.", "4": "Je bent €1 vergeten." }
  },
  {
    "id": "GELD-SAMEN-L2-003",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Maak precies €12,85",
    "options": ["1000", "500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 1285,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-COMBO-3",
    "explanation": "Je moet €12,85 maken. Bijvoorbeeld: €10 + €2 + 50 cent + 20 cent + 10 cent + 5 cent = €12,85.",
    "distractorExplanations": { "1": "Je hebt te weinig gekozen. €12,85 is 1285 cent.", "2": "Je hebt te veel gekozen. Tel je munten en biljetten nog eens na.", "3": "Je bent 50 cent vergeten.", "4": "Je bent €1 vergeten." }
  },
  {
    "id": "GELD-WISSEL-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Een boek kost € 12,75. Je betaalt met € 20,00. Maak het wisselgeld",
    "options": ["500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 725,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-MEDIUM-1",
    "explanation": "Je betaalt €20 voor iets van €12,75. Wisselgeld: €20 - €12,75 = €7,25.",
    "distractorExplanations": { "1": "Je hebt te weinig wisselgeld gemaakt. €20 - €12,75 = €7,25.", "2": "Je hebt te veel wisselgeld gemaakt. €20 - €12,75 = €7,25.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-WISSEL-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Je koopt voor € 8,35 en betaalt met € 10,00. Maak het wisselgeld",
    "options": ["200", "100", "50", "20", "10", "5"],
    "correctAnswer": 165,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-MEDIUM-2",
    "explanation": "Je betaalt €10 voor iets van €8,35. Wisselgeld: €10 - €8,35 = €1,65.",
    "distractorExplanations": { "1": "Je hebt te weinig wisselgeld gemaakt. €10 - €8,35 = €1,65.", "2": "Je hebt te veel wisselgeld gemaakt. €10 - €8,35 = €1,65.", "3": "Je bent 50 cent vergeten.", "4": "Je bent €1 vergeten." }
  },
  {
    "id": "GELD-WISSEL-L2-003",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Een speelgoed kost € 15,60. Je geeft € 20,00. Maak het wisselgeld",
    "options": ["500", "200", "100", "50", "20", "10", "5"],
    "correctAnswer": 440,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-MEDIUM-3",
    "explanation": "Je betaalt €20 voor iets van €15,60. Wisselgeld: €20 - €15,60 = €4,40.",
    "distractorExplanations": { "1": "Je hebt te weinig wisselgeld gemaakt. €20 - €15,60 = €4,40.", "2": "Je hebt te veel wisselgeld gemaakt. €20 - €15,60 = €4,40.", "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.", "4": "Je bent €1 vergeten of hebt verkeerd geteld." }
  },
  {
    "id": "GELD-BOOD-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Je koopt: kaas € 3,75, ham € 2,50, brood € 1,80. Wat is het totaalbedrag?",
    "options": ["€ 8,05", "€ 7,05", "€ 8,50", "€ 7,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "GELD-BOOD-MEDIUM-1",
    "explanation": "Kaas €3,75 + ham €2,50 + brood €1,80 = €8,05.",
    "distractorExplanations": { "1": "Je bent €1 vergeten. €3,75 + €2,50 + €1,80 = €8,05.", "2": "Je hebt 45 cent te veel geteld. €3,75 + €2,50 + €1,80 = €8,05.", "3": "Je hebt 55 cent te weinig geteld. €3,75 + €2,50 + €1,80 = €8,05." }
  },
  {
    "id": "GELD-BOOD-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Een pak koekjes kost € 2,25. Je koopt 3 pakken. Hoeveel betaal je in totaal?",
    "options": ["€ 6,75", "€ 6,25", "€ 7,25", "€ 5,75"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "GELD-BOOD-MEDIUM-2",
    "explanation": "3 pakken × €2,25 = €6,75.",
    "distractorExplanations": { "1": "Je hebt 50 cent te weinig. 3 × €2,25 = €6,75.", "2": "Je hebt 50 cent te veel. 3 × €2,25 = €6,75.", "3": "Je hebt €1 te weinig. 3 × €2,25 = €6,75." }
  },
  {
    "id": "GELD-SPAAR-L2-001",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Je krijgt elke week € 5,00 zakgeld. Na hoeveel weken heb je € 30,00 gespaard?",
    "options": ["6 weken", "5 weken", "7 weken", "4 weken"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "GELD-SPAAR-MEDIUM-1",
    "explanation": "Je wilt €30 en krijgt €5 per week. €30 ÷ €5 = 6 weken.",
    "distractorExplanations": { "1": "Na 5 weken heb je pas €25. Je hebt 6 weken nodig.", "2": "Na 7 weken heb je €35. Je hebt maar 6 weken nodig.", "3": "Na 4 weken heb je pas €20. Je hebt 6 weken nodig." }
  },
  {
    "id": "GELD-SPAAR-L2-002",
    "module": "TijdGeld",
    "difficulty": 104,
    "question": "Je hebt € 45,00. Een game kost € 35,00. Hoeveel houd je over na aankoop?",
    "options": ["€ 10,00", "€ 15,00", "€ 5,00", "€ 80,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "GELD-SPAAR-MEDIUM-2",
    "explanation": "Je hebt €45. De game kost €35. Je houdt over: €45 - €35 = €10.",
    "distractorExplanations": { "1": "Je hebt €5 te veel berekend. €45 - €35 = €10.", "2": "Je hebt €5 te weinig berekend. €45 - €35 = €10.", "3": "Je hebt opgeteld in plaats van afgetrokken. €45 - €35 = €10." }
  }
]
